import {useCallback, useEffect, useState} from "react";
import {Box, Button, Grid, makeStyles} from "@material-ui/core";
import {useDispatch, useSelector} from "react-redux";
import {
  moveNextPage,
  mutationUpdateUserMetricValue,
  updateAsyncThumbnailImg,
  updateUserMetrics
} from "../../../../../store/actions/creator/creatorExperienceBuilder";
import {apiClient} from "../../../../../config/apiClient";
import {createExperience, createUserPreference, updateUserPreference} from "../../../../../store/actions";
import Config from "../../../../../config/config";
import UtilService from '../../../../../helper/service';
import roles from "../../../../../helper/roles";
import {useHistory, useLocation} from "react-router";
import {updateUserMetricsValue} from '../../../../../store/actions/auth/auth';
import {Loading} from "../../../../atoms/commonLoadings";

const useStyles = makeStyles(() => ({
  mainTitle: {
    fontSize: '48px',
    fontFamily: 'Spartan-bold',
    color: '#212D40',
    textAlign: 'center',
    '@media only screen and (max-width: 1440px)': {
      marginBottom: '25px'
    },
    '@media only screen and (max-width: 600px)': {
      fontSize: '20px'
    }
  },
  subTitle: {
    fontSize: 23,
    fontFamily: 'roboto-bold',
    margin: '25px 0 0',
    color: '#697683',
    '@media only screen and (max-width: 1440px)': {
      margin: '20px 0 0'
    }
  },
  subTitle1: {
    fontSize: 23,
    margin: '0',
    fontFamily: 'roboto-bold',
    color: '#697683'
  },
  description: {
    fontSize: 17,
    fontFamily: 'roboto-regular',
    color: '#017AEF',
    margin: '12px 0 0',
    cursor: 'pointer',
    '@media only screen and (max-width: 1440px)': {
      margin: '6px 0 0'
    },
    '&:hover': {
      color:'#0f9fef'
    }
  },
  videoClip: {
    width: 207,
    height: 152,
    marginTop: 30,
    '@media (max-width: 959px)': {
      marginTop: 20,
    },
  },
  noneInvite: {
    fontSize: 18,
    fontFamily: 'roboto-bold',
    color:'#ED564A'
  },
  goLiveBtn: {
    width: 144,
    height: 54,
    borderRadius: 6,
    background: '#017AEF',
    color: '#fff',
    textTransform: 'none',
    fontSize: 19,
    float: 'right',
    '&:hover': {
      background: '#0f9fef',
      color: '#fff',
    },
  }
}));

const PreRecordedReview = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const { userMetrics, page, asyncThumbnailImg, categories } = useSelector((state: any) => state.creatorExperienceBuilder);
  const {
    asyncExperienceName,
    asyncStartDateTime,
    asyncEndDateTime,
    sessionCode,
    stimulusList,
    streamType,
    asyncFileName,
    asyncCompleted,
    asyncParticipants,
    item,
    content,
    myOwn,
    braintrust,
    updateBraintrustMetrics,
    startNow,
    measureWay,
    compatible,
    save_setting,
    asyncLastActivePage,
    selectedHubs
  } = userMetrics;

  const [videoStatus, setVideoStatus] = useState('');
  const { is_loading, totalExperienceCount } = useSelector((state: any) => state.experience);
  const { userPreferencesData } = useSelector((state: any) => state.authUser);
  const apolloClient = useSelector((state: any) => state.apolloClient);
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : ""

  useEffect(() => {
    if (history.location.hash !== '#asyncgo') {
      UtilService.addHashTag(history, location.pathname, 'asyncgo');
    }
  }, []);

  useEffect(() => {
    const getStimulus = async () => {
      const res = await apiClient(true).get(`/stimulus/v2/stimulus/${loginUserData.customer_id}/${sessionCode}`);
      dispatch(updateUserMetrics('stimulusList', res.data))
    };
    getStimulus();
  }, [dispatch, loginUserData.customer_id, sessionCode]);

  useEffect(() => {
    if (stimulusList.length > 0) {
      setVideoStatus(stimulusList[0]['stimulus_status']);
      if (stimulusList[0]['stimulus_status'] === "PROCESSING-SENTTOVDO") {
        if (stimulusList[0]['stimulus_type'] === "AUDIO") {
          const defaultImageAudio = '/assets/icons/experiencebuilder/video-proccessing.png';
          dispatch(updateAsyncThumbnailImg(defaultImageAudio))
        } else {
          const defaultImage = '/assets/icons/experiencebuilder/video-proccessing.png';
          dispatch(updateAsyncThumbnailImg(defaultImage))
        }
      } else {
        const thumbnails = stimulusList[0]['thumbnails'];
        if (thumbnails && thumbnails.length > 0) {
          if (stimulusList[0]['stimulus_type'] === "AUDIO") {
            const defaultImageAudio = '';
            dispatch(updateAsyncThumbnailImg(defaultImageAudio))
          } else {
            const descendedThumbs = thumbnails.sort((a: any, b: any) => b.width - a.width);
            dispatch(updateAsyncThumbnailImg(descendedThumbs[0]['url']))
          }
        }
      }
    }
  }, [stimulusList]);

  const onFinish = () => {
    if (!asyncCompleted) {
      const allemails: any = [];
      asyncParticipants.map((item: any) => {
        const tags: any = [];
        if (item.tags) {
          const itemTags = item.tags.split(",");
          if (itemTags && itemTags.length > 0) {
            itemTags.map((t: any) => {
              if (t && t.trim()) {
                tags.push({ tag_name: t.trim() })
              }
            })
          }
        }
        allemails.push({ email: item.email, tags: tags, is_csv: item.is_csv })
      });

      const request = {
        disable_fingerpulse: userMetrics.disable_fingerpulse,
        title: userMetrics.asyncExperienceName,
        description: '',
        scheduled_start: userMetrics.asyncStartDateTime,
        scheduled_end: userMetrics.asyncEndDateTime,
        user_id: loginUserData.user_id,
        status: 'UPCOMING',
        type: 'ASYNC',
        session_code: sessionCode,
        subcategory: item,
        category: content,
        enable_controls: userMetrics.enable_controls,
        surveylink: userMetrics.surveyLink,
        enable_watermark: userMetrics.enable_watermark,
        participants: allemails,
        braintrust_id: braintrust && braintrust.braintrust_id ? braintrust.braintrust_id : "",
        braintrust_demo: braintrust && braintrust.sample_video_link ? true : false,
        hubs: selectedHubs,
        session_origin:userMetrics?.iscopyExperience ? "COPY_EXPERIENCE": null,
      };
      
      dispatch(createExperience(apolloClient.client, request, () => {
        if (updateBraintrustMetrics) {
          dispatch(updateUserMetricsValue(apolloClient.client, { user_id: loginUserData.user_id, metrics_type: "BRAINTRUST_USES" }));
          dispatch(updateUserMetrics('updateBraintrustMetrics', false))
        }
        if (measureWay === 1 && compatible !== -1 && save_setting) {
          onSaveSettings();
        }
        dispatch(updateUserMetrics('braintrust', null));
        dispatch(updateUserMetrics('asyncCompleted', true));
        dispatch(updateUserMetrics('iscopyExperience', false));
        dispatch(moveNextPage(page + 1));
        (asyncLastActivePage < page + 1) && dispatch(updateUserMetrics('asyncLastActivePage', page + 1));
      }))
    } else {
      dispatch(moveNextPage(page + 1));
      (asyncLastActivePage < page + 1) && dispatch(updateUserMetrics('asyncLastActivePage', page + 1));
    }
  };

  const onSaveSettings = () => {
    const req = {
      user_id: Number(loginUserData.user_id),
      metrix_type: 'EXPERIENCE_CREATE_SETTING',
      metrix_value: {
        compatible: compatible,
        save_setting: save_setting
      }
    };
    dispatch(mutationUpdateUserMetricValue(apolloClient.client, req));
    // update user preference data for ASKEVERYTIME
    const pf_id = userPreferencesData.filter((data: any) => data.preference_name === 'ASKEVERYTIME').length ? (userPreferencesData.filter((data: any) => data.preference_name === 'ASKEVERYTIME'))[0].preference_id : "";
    if (pf_id) { // updating
      const req = {
        preference_value: !save_setting,
        preference_id: pf_id,
        preference_information: '',
        user_id: loginUserData.user_id
      };
      dispatch(updateUserPreference(apolloClient.client, req));
    } else { // creating
      const req = {
        preference_information: '',
        preference_value: !save_setting,
        preference_type: '11',
        preference_name: 'ASKEVERYTIME',
        user_id: loginUserData.user_id
      };
      dispatch(createUserPreference(apolloClient.client, req));
    }
  };

  const trialFirstExperienceNotMyOwn = useCallback(() => {
    if (!!loginUserData) {
      return !!(UtilService.checkTrialAccess(loginUserData, roles['trial']['builder']) && totalExperienceCount === 0 && !myOwn);
    } else {
      return false;
    }
  }, [loginUserData]);

  const getExperienceType = useCallback(() => {
    const selectedCategory = categories['async'].find((category: any) => category['category'] === content);
    if (selectedCategory && selectedCategory['subcategories']) {
      const subCategories = selectedCategory['subcategories'];
      if (subCategories) {
        const selectedSubCategory = content !== 'OTHER' && subCategories.find((subcategory: any) => subcategory['subcategory'] === item);
        return `Pre Recorded > ${selectedCategory['display_category']} ${content === 'OTHER' ? `> ${item}` : (selectedSubCategory ? `> ${selectedSubCategory['display_subcategory']}` : '')}`
      } else {
        return `Pre Recorded`;
      }
    }
    return 'Pre Recorded'
  }, [content, item, categories]);

  return (
    <div>
      <p className={classes.mainTitle}>Review/Edit and GO LIVE!</p>
      <Grid container spacing={2} >
        <Grid item xs={12} md={8}>
          <p className={classes.subTitle1}>Experience Name</p>
          <p className={classes.description} onClick={() => !trialFirstExperienceNotMyOwn() && dispatch(moveNextPage(1))}>
            {asyncExperienceName}
          </p>
          {!trialFirstExperienceNotMyOwn() && (
            <>
              <p className={classes.subTitle}>Experience Type</p>
              <p className={classes.description} onClick={() => dispatch(moveNextPage(0))}>
                {`${getExperienceType()}`}
              </p>
            </>
          )}
          <p className={classes.subTitle}>Video Clip</p>
          {
            (!trialFirstExperienceNotMyOwn() && videoStatus !== 'READY') && <p className={classes.description} onClick={() => dispatch(moveNextPage(1))}>Processing...</p>
          }
          {
            streamType === 'VDO' ? (
              <p className={classes.description} onClick={() => dispatch(moveNextPage(1))}>
                {asyncFileName}
              </p>
            ) : (
              <p className={classes.description} onClick={() => !trialFirstExperienceNotMyOwn() && dispatch(moveNextPage(1))}>
                {stimulusList.length > 0 && `URL: ${stimulusList[0]['stimulus_link']}`}
              </p>
            )
          }
          <Box>
            <img src={asyncThumbnailImg ? asyncThumbnailImg : '/assets/images/placeholder.png'} className={classes.videoClip} alt={'img'}/>
          </Box>
          <p className={classes.subTitle}>Viewing Window</p>
          <p className={classes.description} onClick={() => !trialFirstExperienceNotMyOwn() && dispatch(moveNextPage(2))}>
            {`${startNow ? `Now (${UtilService.getParticipantDateFormatString(asyncStartDateTime)})` : UtilService.getParticipantDateFormatString(asyncStartDateTime)} - ${UtilService.getParticipantDateFormatString(asyncEndDateTime)}`}
          </p>
          <p className={classes.subTitle}>Viewing Link</p>
          <p className={classes.description} onClick={() => dispatch(moveNextPage(4))}>
            {Config.DEV_ASYNC_INVITE_URL}{loginUserData && loginUserData.invite_link_type === "b" ? '/participant':''}/{sessionCode}
          </p>
          <p className={classes.subTitle}>Participants</p>
          <p className={classes.description} onClick={() => dispatch(moveNextPage(4))}>
            {
              asyncParticipants.length > 0 ? (
                <span>{asyncParticipants.length} Participants added</span>
              ) : (
                <span>
                  <span className={classes.noneInvite}>None invited yet.</span> <span style={{color: '#697683'}}>Send the link above…or</span> go
                  to the previous step to add them.
                </span>
              )
            }
          </p>
        </Grid>
        <Grid item xs={12} md={4}>
          <Box justifyContent="center" display="flex">
            <Button color='primary' size='large' className={classes.goLiveBtn} onClick={onFinish} disabled={is_loading ? true : false}>
              {
                !is_loading ? (!asyncCompleted ? 'Go Live!' : 'Next') : (
                  <Loading />
                )
              }
            </Button>
            
          </Box>
        </Grid>
      </Grid>
      <br/><br/><br/><br/>
    </div>
  )
}

export default PreRecordedReview;
